<template>
	<div id="app" @mousemove="handleMouseMove">
		<div class="nav-container" :class="{ 'header--hidden': showNavbar }" :style="`background-image: `+bgcolor+`;`">
			<div class="flex-row-spacebetween-center" style="width: 100%;height: 100%;">
				<div v-if="pageWidth > 768" class="flex-row-spacebetween-center" style="flex: 1;height: 100%;">
					<img src="./assets/logo_temp.png" style="width: 220px;height: auto;" />
					<div class="flex-row-end-center" style="flex: 1;height: 100%;">
						<div class="flex-row-center-center" @click="navIndex=0" @mouseenter="mouseIndex=0"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/" @click="handleRoute('/', 0)" class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 0 }">首页</span>
						</div>
						<div class="flex-row-center-center" @click="navIndex=1" @mouseenter="mouseIndex=1"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/" @click="handleRoute('/news', 1)" class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 1 }">政务资讯</span>
						</div>
            <!-- <div class="flex-row-center-center" @click="navIndex=2" @mouseenter="mouseIndex=2"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/" @click="handleRoute('/news1', 2)" class="t7Font whiteColor flex-row-center-center"
								:class="{ 'nav-active': navIndex === 2 }">资讯</span>
						</div>-->

						 <el-dropdown @command="handleCommand('zczx', $event)">
							<span class="el-dropdown-link" :class="{ 'nav-active': navIndex === 2 }">
								行业资讯
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="/news1">航空文化</el-dropdown-item>
								<el-dropdown-item command="/news2">科研机构</el-dropdown-item>
								<el-dropdown-item command="/news3">合作院校</el-dropdown-item>
								<el-dropdown-item command="/news4">园区企业</el-dropdown-item>
								<el-dropdown-item command="/news5">领军人才</el-dropdown-item>
								<el-dropdown-item command="/news6">园区政策</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<div class="flex-row-center-center" @click="index=3" @mouseenter="mouseIndex=3"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/nrck" @click="handleRoute('/nrck', 3)"
								class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 3 }">人才库</span>
						</div>
						<div class="flex-row-center-center" @click="index=4" @mouseenter="mouseIndex=4"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/nrcxq" @click="handleRoute('/nrcxq', 4)"
								class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 4 }">共享人才智库</span>
						</div>

						<div class="flex-row-center-center" @click="index=5" @mouseenter="mouseIndex=5"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/ngwxq" @click="handleRoute('/ngwxq', 5)"
								class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 5 }">共享人才招聘</span>
						</div>

						<div class="flex-row-center-center" @click="index=6" @mouseenter="mouseIndex=6"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
										<span href="/nxmxq" @click="handleRoute('/nxmxq', 6)"
								class="t7Font whiteColor flex-row-center-center clickable"
								:class="{ 'nav-active': navIndex === 6 }">项目共亨</span>
						</div>

						<div class="flex-row-center-center" @click="index=7" @mouseenter="mouseIndex=7"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<span href="/Login" class="t7Font whiteColor flex-row-center-center clickable" @click="bindJump"
								:class="{ 'nav-active': navIndex === 7 }">个人求职</span>
						</div>

						<div class="flex-row-center-center" @click="index=8" @mouseenter="mouseIndex=8"
							@mouseleave="mouseIndex=null" style="margin: 0 20px;">
							<a href="https://rencai.51dgf.cn/" target="_blank"
								class="t7Font whiteColor flex-row-center-center">工作台</a>
						</div>

					</div>
				</div>
				<div v-else class="flex-row-start-center" style="flex: 1;height: 100%;">
					<img src="./assets/logo_temp.png" style="width: 150px;height: auto;" />
					<div class="flex-row-end-center" style="flex: 1;height: 100%;">
						<div class="flex-row-end-center" style="width: 40px;height: 40px;"
							@click="clickMenu=!clickMenu">
							<img v-if="clickMenu" src="../src/assets/home_cha.png" style="width: 24px;height: auto;" />
							<img v-else src="../src/assets/home_caidan.png" style="width: 24px;height: auto;" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="clickMenu" class="whiteBgColor flex-column-start-center"
			style="height: 100vh;width: 100%;z-index: 99999;top: 60px;position: fixed;left: 0;">
			<div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" href="/" @click="handleRoute('/', 0)"
					style="width: 100%;height: 100%;color: #b68f51;">首页</span>
			</div>
      <div class="flex-row-start-center"
           style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" href="/news" @click="handleRoute('/news', 1)"
              style="width: 100%;height: 100%;color: #b68f51;">政务资讯</span>
      </div>
      <div class="flex-row-spacebetween-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;"
				@click="clickMenuIndex==2?clickMenuIndex=0:clickMenuIndex=2">
				<div class="t4Font blackColor">
					行业资讯
				</div>
				<img v-if="clickMenuIndex==2" src="../src/assets/home_jian.png" style="width: 15px;height: 15px;" />
				<img v-else src="../src/assets/home_jia.png" style="width: 15px;height: 15px;" />
			</div>
			<div v-if="clickMenuIndex==2" class="flex-column-center-center"
				style="width: 100%;background-color: #f9f9f9;">
				<div class="flex-row-start-center"
					style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 40px;box-sizing: border-box;height: 50px;">
					<span class="t4Font blackColor" href="/news1" @click="handleRoute('/news1', 2)"
						style="width: 100%;height: 100%;">航空文化</span>
				</div>
				<div class="flex-row-start-center"
					style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 40px;box-sizing: border-box;height: 50px;">
					<span class="t4Font blackColor" href="/news2" @click="handleRoute('/news2', 2)"
						style="width: 100%;height: 100%;">科研机构</span>
				</div>
				<div class="flex-row-start-center"
					style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 40px;box-sizing: border-box;height: 50px;">
					<span class="t4Font blackColor" href="/news3" @click="handleRoute('/news3', 2)"
						style="width: 100%;height: 100%;">合作院校</span>
				</div>
        <div class="flex-row-start-center"
          style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 40px;box-sizing: border-box;height: 50px;">
					<span class="t4Font blackColor" href="/news4" @click="handleRoute('/news4', 2)"
           style="width: 100%;height: 100%;">园区企业</span>
        </div>
        <div class="flex-row-start-center"
          style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 40px;box-sizing: border-box;height: 50px;">
					<span class="t4Font blackColor" href="/news5" @click="handleRoute('/news5', 2)"
           style="width: 100%;height: 100%;">领军人才</span>
        </div>
        <div class="flex-row-start-center"
          style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 40px;box-sizing: border-box;height: 50px;">
					<span class="t4Font blackColor" href="/news6" @click="handleRoute('/news6', 2)"
           style="width: 100%;height: 100%;">园区政策</span>
        </div>
			</div>

			<div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" href="/nrck" @click="handleRoute('/nrck', 3)"
					style="width: 100%;height: 100%;color: #b68f51;">人才库</span>
			</div>
			<div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" href="/nrcxq" @click="handleRoute('/nrcxq', 4)"
					style="width: 100%;height: 100%;color: #b68f51;">共享人才智库</span>
			</div>

			<div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" href="/ngwxq" @click="handleRoute('/ngwxq', 5)"
					style="width: 100%;height: 100%;color: #b68f51;">共享人才招聘</span>
			</div>

      <div class="flex-row-start-center"
           style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span class="t7Font" href="/nxmxq" @click="handleRoute('/nxmxq', 6)"
              style="width: 100%;height: 100%;color: #b68f51;">项目共亨</span>
      </div>

			<!-- <div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<span href="/Login" class="t4Font whiteColor flex-row-start-cente"
					style="width: 100%;height: 100%;color: #b68f51; cursor: pointer;" @click="bindJump">个人求职</span>
			</div>

			<div class="flex-row-start-center"
				style="width: 100%;border-bottom: 1px solid #eee;padding: 10px 20px;box-sizing: border-box;">
				<a class="t4Font" href="https://rencai.51dgf.cn/" target="_blank" style="width: 100%;height: 100%;color: #b68f51;">工作台</a>
			</div> -->

		</div>
		<keep-alive>
			<!-- 只缓存带有 keepAlive 标记的组件 -->
			<router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
		</keep-alive>

		<!-- 不缓存的组件 -->
		<router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		},
		data() {
			return {
				oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
				scrollTop: 0, // 记录当前的滚动距离
				bgcolor: 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))!important;',
				tran_flag: true,
				showNavbar: false,
				fade: '',
				index: 0,
				mouseIndex: null,
				mousechiIndex: null,
				pageWidth: window.innerWidth,
				clickMenu: false,
				clickMenuIndex: 0,
				activeMenu: '', // 当前高亮的一级菜单
				navIndex: 0, //导航栏选中的下标
			}
		},
		created() {
			console.log('进入主页', window.location.href);
			this.clickMenu = false
			this.clickMenuIndex = 0
			if (window.location.href.includes('store')) {
				this.index = 1
			} else if (window.location.href.includes('dishes')) {
				this.index = 2
			} else if (window.location.href.includes('shop')) {
				this.index = 3
			} else if (window.location.href.includes('connectUs')) {
				this.index = 4
			} else if (window.location.href.includes('brandIntroduction')) {
				this.index = 5
			} else {
				this.index = 0
			}
		},
		watch: {
			// scrollTop(newValue, oldValue) {
			// 	setTimeout(() => {
			// 		if (newValue == window.scrollY) { //延时执行后当newValue等于window.scrollY，代表滚动结束
			// 			console.log('滚动结束');
			// 			this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
			// 			this.tran_flag = true;
			// 		};
			// 	}, 300); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
			// 	if (this.oldScrollTop == oldValue) { //每次滚动开始时oldScrollTop与oldValue相等
			// 		console.log('滚动开始');
			// 		this.tran_flag = false;
			// 	}
			// }
		},

		mounted() {
			// window.addEventListener('scroll', this.handleScroll);
			// window.addEventListener('resize', this.handleResize);
			document.title = '航空人才共享网';
		},
		beforeDestroy() {
			// window.removeEventListener('scroll', this.handleScroll);
			// window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			bindJump() {
				this.navIndex = 7;
				const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
				if (isLoggedIn) {
					this.$router.push("/LoginHomeView");
				} else {
					this.$router.push("/Login");
				}
				this.clickMenu = false;
			},
			handleResize() {
				this.pageWidth = window.innerWidth;
				if (this.pageWidth < 1005) {
					this.clickMenu = false
					this.clickMenuIndex = 0
				}
			},
			dropdownChange1(e) {
				// this.$message('click on item ' + e);
				if (!e && this.mouseIndex == 1) {
					this.mouseIndex = null
				}
			},
			dropdownChange2(e) {
				// this.$message('click on item ' + e);
				if (!e && this.mouseIndex == 2) {
					this.mouseIndex = null
				}
			},
			handleScroll() {
				const currentScrollTop = document.documentElement.scrollTop
				this.scrollTop = currentScrollTop
				// if (currentScrollTop > this.oldScrollTop) {
				// 	this.showNavbar = true
				// } else {
				// 	this.showNavbar = false
				// }
				if (currentScrollTop > 0) {
					this.showNavbar = true
					this.mouseIndex = null
				} else {
					this.showNavbar = false
				}
			},
			handleMouseMove(event) {
				// 检查鼠标是否在顶部区域（比如顶部60像素内）
				if (event.clientY <= 60) {
					this.showNavbar = false
				} else {
					if (this.scrollTop > 0) {
						this.showNavbar = true
					}
				}
			},
			handleCommand(menuName, command) {
				console.log("***handleCommand:", menuName, command);
				// 改变高亮
				this.activeMenu = menuName;
				this.navIndex = 2;
        this.$router.push(command);
			},
			handleRoute(path, index) {
				this.navIndex = index;
				this.$router.push(path);
				this.clickMenu = false;
			},
			pushHome() {},
			pushStore() {},
			pushUs() {},
		}
	}
</script>

<style>
	@import "../common/css/common.css";

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	* {
		margin: 0;
		padding: 0;
		border: 0;
	}

	html,
	body,
	* {
		/* cursor: url('./assets/shubiao.png'), default; */
		/* cursor: pointer; */
	}

	.nav-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 60px;
		padding: 0 10px;
		box-sizing: border-box;
		transition: opacity 0.5s ease-in-out;
		z-index: 9999;
	}

	.header--hidden {
		opacity: 0;
		pointer-events: none;
	}

	.no-border {
		border: none;
	}

	.el-menu {
		transition: all 0.3s;
	}

	.el-menu.el-menu--horizontal {
		border: none;
	}

	::-webkit-scrollbar {
		width: 0 !important;
	}

	::-webkit-scrollbar {
		width: 0 !important;
		height: 0;
	}

	/* 消除小三角 */
	/* .el-popper[x-placement^=bottom] .popper__arrow {
		border: none;
	}

	.el-popper[x-placement^=bottom] .popper__arrow::after {
		border: none;
	} */

	/* .expand-enter-active,
	.expand-leave-active {
		transition: all 0.5s ease;
	} */

	.el-dropdown-link {
		cursor: pointer;
		color: white;
		font-size: 19px;
		/* font-weight: bold; */
		padding-left: 8px;
		padding-right: 8px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.nav-active {
		color: #409EFF !important;
		/* font-weight: bold; */
	}

	/* 全局样式文件：styles.css 或 App.vue 的全局样式 */
	.global-center-message {
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		position: fixed !important;
		z-index: 999999 !important;
	}

	/* 如果需要所有消息都在中间 */
	.el-message {
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		position: fixed !important;
	}

</style>